import { toast } from 'react-toastify';
// mui
import { styled } from '@mui/material';
//////////////////////////////////////////////////

const StyledTextToast = styled('p')(({ theme }) => ({
  zIndex: 99999,
  maxWidth: 350,
  minWidth: 250,
  textAlign: 'start',
  whiteSpace: 'pre-line',
  wordBreak: 'break-word',
  fontFamily: 'Roboto, sans-serif',

  [theme.breakpoints.down('md')]: {
    fontSize: 12,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 9,
  },
  '&:first-letter': {
    textTransform: 'capitalize',
  },
}));

// use with wait/async
// eslint-disable-next-line require-yield
function* showToastrMessage(type, message, autoClose) {
  toast(<StyledTextToast>{message}</StyledTextToast>, {
    type,
    rtl: false,
    draggable: true,
    closeOnClick: true,
    newestOnTop: false,
    pauseOnHover: true,
    position: 'top-left',
    hideProgressBar: false,
    pauseOnFocusLoss: true,
    autoClose: autoClose || 10000,
  });
}

// use with wait/async
const showToastrMessageSimple = (type, message, autoClose) => {
  toast(<StyledTextToast>{message}</StyledTextToast>, {
    type,
    rtl: false,
    draggable: true,
    closeOnClick: true,
    newestOnTop: false,
    pauseOnHover: true,
    position: 'top-left',
    hideProgressBar: false,
    pauseOnFocusLoss: true,
    autoClose: autoClose || 10000,
  });
};

export { showToastrMessage, showToastrMessageSimple };
